<script lang="ts" setup>
import type { NestedMenuType } from './menu';

const props = defineProps({
  menus: {
    type: Array as () => NestedMenuType[],
    required: true,
  },
  inlineIndent: {
    type: Number,
    default: 6,
  },
  defaultAllOpen: {
    type: Boolean,
    default: false,
  },
})

const $emits = defineEmits<{
  (e: 'openChange', v: string[]): void,
  (e: 'select', v: string[]): void
}>()

const openMenus = ref<string[]>(props.defaultAllOpen ? props.menus.map((menu) => menu.id) : [])
const selectedMenus = ref<string[]>([])

// console.log('openmenus', openMenus.value, props.menus)
const onChangeOpen = () => {
  // console.log('onChangeOpen', openMenus.value)
  $emits('openChange', openMenus.value)
}
const onChangeSelected = () => {
  // console.log('onChangeSelected', selectedMenus.value)
  $emits('select', selectedMenus.value)
}
</script>

<template>
<!-- <div v-if="menus.length === 0" class="py-2 px-4 text-gray-400">
  No sub categories
</div> -->
<a-collapse v-model:activeKey="openMenus" @change="onChangeOpen" expand-icon-position="right">
  <template v-for="menu in menus" :key="menu.id">
    <a-collapse-panel :header="menu.label" v-if="menu.childs && menu.childs.length > 0" :key="menu.id">
      <div v-for="subMenu in menu!.childs" :key="subMenu.id" v-if="menu.childs && menu.childs.length > 0">
        <router-link :to="subMenu.uri" v-if="!subMenu.childs || subMenu.childs.length === 0">
          <component :is="subMenu.icon" v-if="subMenu.icon"></component>
          <span class="inline-block py-2 px-4">
            {{ subMenu.label }}
          </span>
        </router-link>
        <LayoutsMenuNestedMenu :menus="subMenu.childs" v-if="subMenu.childs && subMenu.childs.length > 0" />
      </div>

      <!-- <template #extra><setting-outlined @click="handleClick" /></template> -->
    </a-collapse-panel>
    <div v-if="!menu.childs || menu.childs.length === 0" class="py-2 px-4">
      <router-link :to="menu.uri">
        {{ menu.label }}
      </router-link>
    </div>
  </template>
</a-collapse>
</template>

<style >
.ant-collapse-content > .ant-collapse-content-box {
  padding: 0.2em 0.6em !important;
}

.ant-collapse {
  background: none;
  border: none;
}
</style>